import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Helmet } from "react-helmet-async";
import { SITE_NAME, SITE_URL } from "@/lib/seo-schemas";

const ConditionsUtilisation = () => {
  const breadcrumbItems = [
    { label: "Accueil", href: "/" },
    { label: "Conditions d'utilisation", href: "/conditions-d-utilisation" },
  ];

  return (
    <>
      <Helmet>
        <title>Conditions d'Utilisation | {SITE_NAME}</title>
        <meta name="description" content={`Conditions générales d'utilisation du service ${SITE_NAME}. Consultez les règles d'utilisation de notre plateforme IPTV.`} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`${SITE_URL}/conditions-d-utilisation`} />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        <Breadcrumbs items={breadcrumbItems} />

        <main className="max-w-4xl mx-auto px-4 py-16">
          <h1 className="text-3xl md:text-4xl font-black text-foreground mb-8">Conditions d'Utilisation</h1>
          <p className="text-sm text-muted-foreground mb-8">Dernière mise à jour : 21 février 2026</p>

          <div className="space-y-8 text-muted-foreground leading-relaxed">
            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">1. Objet</h2>
              <p>Les présentes conditions régissent l'utilisation du service {SITE_NAME}, accessible à l'adresse {SITE_URL}. En utilisant notre service, vous acceptez ces conditions dans leur intégralité.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">2. Description du service</h2>
              <p>{SITE_NAME} propose un service d'accès à des contenus audiovisuels en streaming (films, séries, chaînes TV, sport en direct) via une connexion internet.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">3. Inscription et compte</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>L'utilisateur s'engage à fournir des informations exactes lors de son inscription.</li>
                <li>Les identifiants de connexion sont personnels et ne doivent pas être partagés.</li>
                <li>L'utilisateur est responsable de la sécurité de son compte.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">4. Tarifs et paiement</h2>
              <p>Les tarifs sont indiqués sur la page Nos Offres. Les paiements sont sécurisés via Stripe. L'abonnement prend effet immédiatement après le paiement.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">5. Test gratuit</h2>
              <p>Un test gratuit de 24 heures est proposé. Il est limité à un test par adresse email et par appareil.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">6. Utilisation acceptable</h2>
              <p>L'utilisateur s'engage à ne pas utiliser le service à des fins illégales, à ne pas redistribuer les contenus, et à respecter les droits de propriété intellectuelle.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">7. Limitation de responsabilité</h2>
              <p>{SITE_NAME} s'efforce de maintenir un service de qualité mais ne peut garantir une disponibilité ininterrompue. En cas de problème technique, notre support intervient dans les meilleurs délais.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">8. Contact</h2>
              <p>Pour toute question : <a href="mailto:contact@roidustreaming.fr" className="text-primary hover:underline">contact@roidustreaming.fr</a></p>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default ConditionsUtilisation;
